/* global axios */
import ApiClient from 'dashboard/api/ApiClient';

class PipelineWebhooksAPI extends ApiClient {
  constructor() {
    super('pipeline/webhooks', { accountScoped: true });
  }

  test(id) {
    return axios.post(`${this.url}/${id}/test`);
  }

  regenerateSecret(id) {
    return axios.patch(`${this.url}/${id}/regenerate_secret`);
  }
}

export default new PipelineWebhooksAPI();
